import { Box } from "@mui/material";
import templateLibraryStyles from "../TemplateLibrary.styles";

export type TemplatesTab = "mine" | "library";

const TABS: { value: TemplatesTab; label: string }[] = [
  { value: "mine", label: "My templates" },
  { value: "library", label: "Template library" },
];

/** "My templates" / "Template library" switch under the page header. */
const TemplateTabs = ({
  value,
  onChange,
}: {
  value: TemplatesTab;
  onChange: (tab: TemplatesTab) => void;
}) => (
  <Box role="tablist" aria-label="Templates" sx={templateLibraryStyles.tabs}>
    {TABS.map((tab) => (
      <Box
        key={tab.value}
        component="button"
        type="button"
        role="tab"
        id={`templates-tab-${tab.value}`}
        aria-selected={value === tab.value}
        onClick={() => onChange(tab.value)}
        sx={templateLibraryStyles.tab(value === tab.value)}
      >
        {tab.label}
      </Box>
    ))}
  </Box>
);

export default TemplateTabs;
